import React, { useEffect, useState } from "react";
import { withRouter, useHistory } from "react-router-dom";
import { connect } from "react-redux";
import {
  CloseIcon,
  DocumentIcon,
  ExcelIcon,
  HomeIcon,
  ImageIcon,
  PdfIcon,
  PLusIcon,
  ShareIcon,
  VideoIcon,
  VideosIcon,
} from "../../assets/Icons";
import Search from "../../common/Search";
import FilterBtn from "../Workflow/FilterBtn";
import folderImg from "../../assets/images/folder.png";
import { Button, Form, Modal } from "react-bootstrap";
import axios from "axios";
import { applicationId, UNO_URL } from "../../Server";
import { fileTypeIcons } from "../../constant/constant";
import NoDataFound from "../../common/NoDataFound";
import FolderSkelton from "./FolderSkelton";

const Folders = ({ user, userDetails }) => {
  const [search, setSearch] = useState("");
  const history = useHistory();
  const [loading, setLoading] = useState(true);
  const [createFolder, setCreateFolder] = useState(false);
  const [folderList, setFolderList] = useState([]);

  const getDriveFolders = async (userToken) => {
    try {
      setLoading(true);
      let { data } = await axios.get(`${UNO_URL}/api/drive/folder/list/${applicationId}`, {
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
      });
      setFolderList(data.data || []);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (userDetails?.token) {
      getDriveFolders(userDetails.token);
    }
  }, [user, userDetails]);

  const handleClose = () => setCreateFolder(false);

  let filterFolders = folderList.filter((e) => e.name.toLowerCase().includes(search.toLowerCase()));

  return (
    <>
      <div className="xp-breadcrumbbar">
        <div className="xp-page-title">
          <h3 className="xp-page-title">Files</h3>
        </div>
        <div className="row">
          <div className="col-md-9 col-lg-9">
            <div className="xp-breadcrumb gradient-border">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <a onClick={() => history.push("/dashboard")} style={{ cursor: "pointer" }}>
                    <i>
                      <HomeIcon />
                    </i>
                  </a>
                </li>
                <li className="breadcrumb-item active">Files</li>
              </ol>
            </div>
          </div>
          <div className="col-md-3 col-lg-3 filter-tab">
            <Search onChange={(e) => setSearch(e.target.value)} value={search} placeholder="Search..." />
            {/* <FilterBtn
              selectedCheckboxes={selectedCheckboxes}
              handleReset={handleReset}
              handleCheckboxChange={handleCheckboxChange}
              filterOptions={filterData}
            /> */}
          </div>
        </div>

        <div className="file-header my-3">
          <div className="actionbtns d-flex align-items-center">
            <h5 className="text-dark">Category</h5>
          </div>
          {/* <a className="btn btn-white btn-lg rounded border" onClick={() => setCreateFolder(true)}>
            <PLusIcon /> Add Category
          </a> */}
        </div>
        <div className="folder-grid">
          {loading ? (
            // <p>Data is fetching</p>
            <FolderSkelton count={3} />
          ) : filterFolders.length === 0 ? (
            <NoDataFound headText="No Data found." />
          ) : (
            filterFolders.map((folder, idx) => (
              <div className="folder-card" key={idx}>
                <div
                  className="folder-wrapper"
                  onClick={() =>
                    history.push(`/files/${fileTypeIcons[folder.name.toLowerCase()]["path"]}/${folder.uuid}`)
                  }
                  style={{ cursor: "pointer" }}
                >
                  <img src={folderImg} alt="folder" className="folder-img" />
                  <div className="folder-inner-icon">{fileTypeIcons[folder.name.toLowerCase()]["icon"]}</div>
                </div>
                <p className="folder-label">{folder.name}</p>
              </div>
            ))
          )}
        </div>
      </div>

      <Modal size="lg" show={createFolder} onHide={handleClose} centered backdrop={true} keyboard={true}>
        <Modal.Header>
          <Modal.Title>Create Category</Modal.Title>
          <button onClick={handleClose} className="close-s schedule-modal-button" type="button" title="Close">
            <CloseIcon />
          </button>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group controlId="fileName">
              <Form.Label>Category Name</Form.Label>
              <Form.Control type="text" autoFocus placeholder="Category Name" />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer className="py-2 justify-content-end" onClick={() => setCreateFolder(false)}>
          <Button variant="primary">Create</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

const mapStateToProps = (state) => ({
  user: state.userData,
  userDetails: state.userData.userDetails,
});

export default withRouter(connect(mapStateToProps)(Folders));
